export default class PositionCallsStatusT {
  front: number[];

  rear: number[];

  frontLock: number[];

  rearLock: number[];

  constructor(
    front: number[] = [],
    rear: number[] = [],
    frontLock: number[] = [],
    rearLock: number[] = [],
  ) {
    this.front = front;
    this.rear = rear;
    this.frontLock = frontLock;
    this.rearLock = rearLock;
  }
}
